import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printlabfooterview',
  templateUrl: './printlabfooterview.component.html',
  styleUrls: ['./printlabfooterview.component.scss']
})

export class  PrintlabfooterviewComponent implements OnInit {
  
  public Date: Date;

 

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

    this.Date = new Date();
  }
  

 
 
 


 
}
